import React from "react";
import "./loadingSpinner.css"; // create this or reuse your existing CSS

export default function LoadingSpinner() {
  return (
    <>
      <div className="blur-background"></div>
      <div className="loading"></div>
    </>
  );
}
